import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useGetSuggestedContextQuestions = (
  matterId: string | undefined,
  issues: string[],
  parties: string[],
  additionalContext: string,
) => {
  const { getFetchConfig } = useGetFetchConfig();

  // Key only on matterId + issues so typing in the textarea doesn't re-trigger
  return useQuery<string[]>(
    [QueryEntity.MatterSuggestedContext, { matterId, issues, parties }],
    async () => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { issues, parties, additionalContext },
      });
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/suggest-questions`, fetchConfig);
      if (!response.ok) throw new Error('Failed to fetch suggested questions');
      return response.json();
    },
    {
      enabled: !!matterId && issues.length > 0,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
};
